// @storybook-skip: internal section of LessonDetailViewScreen; covered by its screen story
import type { LayoutChangeEvent } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import {
	COVER_TEXT_COLOR,
	COVER_TEXT_SECONDARY_COLOR,
} from "../AnimatedHeaderScreen/constants";
import Box from "../Box";
import { ExpandableText } from "../ExpandableText";

type Props = {
	title: string;
	description: string;
	invertColors?: boolean;
	titleVariant?: "headlineMedium" | "displaySmall";
	onTitleLayout?: (e: LayoutChangeEvent) => void;
};

export const LessonDetailTitleSection = ({
	title,
	description,
	invertColors,
	titleVariant = "displaySmall",
	onTitleLayout,
}: Props) => {
	const theme = useAppTheme();
	const descriptionColor = invertColors
		? COVER_TEXT_SECONDARY_COLOR
		: theme.colors.onSurfaceVariant;
	const expandLinkColor = invertColors
		? COVER_TEXT_COLOR
		: theme.colors.primary;

	return (
		<Box gap={8} paddingHorizontal={16}>
			<Text
				variant={titleVariant}
				style={invertColors ? { color: COVER_TEXT_COLOR } : undefined}
				onLayout={onTitleLayout}
			>
				{title}
			</Text>
			<ExpandableText
				text={description}
				resetKey={description}
				variant="bodyMedium"
				color={descriptionColor}
				expandLinkColor={expandLinkColor}
			/>
		</Box>
	);
};
